<template>
  <div class="container my-4" style="max-width: 540px">
    <Card v-if="isSuccess">
      <template #content>
        <div class="alert alert-success mb-0">
          <span v-if="auth.isAuthenticated()">{{ t("OPERATION_SUCCESSFUL") }}</span>
          <span v-else>{{ t("ACTIVATION_SUCCESS") }}</span>
        </div>

        <div class="text-center">
          <Button class="mt-3" :label="t('PW_LOGIN')" @click="toLogin()" v-if="!auth.isAuthenticated()"/>
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {injectAxios, injectAuth} from "@/util/inject";
import {useI18n} from "vue-i18n";

import {useRoute, useRouter} from "vue-router";

const {t} = useI18n();
const axios = injectAxios();
const auth = injectAuth();
const router = useRouter();
const route = useRoute();

const isSuccess = ref(false);

onMounted(() => {
  if (route.query.token) {
    activate(route.query.token);
  } else {
    router.push({path: "/"});
  }
});

const activate = async (token) => {
  await axios.post(`/account/activate`, {token: token});
  isSuccess.value = true;
};

const toLogin = () => {
  router.push({name: "LoginPassword"});
};
</script>
